import React from "react";

const AllContext = React.createContext();

export default AllContext;
